import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { BackgroundCodesType } from "@services/types";

type UseBackgroundCodesType = {
  backgroundCodesList: BackgroundCodesType[];
  get: (id: BackgroundCodesType["id"]) => BackgroundCodesType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useBackgroundCodes = create<UseBackgroundCodesType>(
  (set, get) => ({
    loading: false,
    backgroundCodesList: [],
    query: "",
    setQuery: (query) => set({ query }),
    get: (id) =>
      get().backgroundCodesList.find((equipment) => equipment.id === id),
    fetchAll: async () => {
      set({ loading: true });
      try {
        const endpoint = "/generic/CodigosFondo";
        const { data: response } = await getData(endpoint);

        set(() => ({
          backgroundCodesList: response,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching useBackgroundCodes:", error);
        set({ loading: false });
      }
    },
  })
);
